import { Language } from 'types/language'
import { Language as UppercaseLanguage, LANGUAGES } from '@boltenergy-be/shared'

/**
 * Type guard to check if the given language is a valid uppercase language
 * @param {string} lng
 * @returns {lng is UppercaseLanguage}
 */
export const isValidUppercaseLanguage = (lng: string): lng is UppercaseLanguage => {
  return Object.values(LANGUAGES).some((l) => l === lng)
}

/**
 * Type guard to check if the given language is a valid lowercase language
 * @param {string} lng
 * @returns {lng is Language}
 */
export const isValidLowercaseLanguage = (lng: string): lng is Language => {
  return Object.values(Language).includes(lng as Language)
}

/**
 * Converts the given language to uppercase
 * @param {Language} lng
 * @returns {UppercaseLanguage}
 */
export const getUpperCaseLanguage = (lng: string): UppercaseLanguage => {
  if (isValidUppercaseLanguage(lng)) return lng
  if (!isValidLowercaseLanguage(lng)) return LANGUAGES.NL

  return lng.toUpperCase() as UppercaseLanguage
}

/**
 * Converts the given language to lowercase
 * @param {string} lng
 * @returns {Language}
 */
export const getLowerCaseLanguage = (lng: string): Language => {
  if (isValidLowercaseLanguage(lng)) return lng
  if (!isValidUppercaseLanguage(lng)) return Language.DUTCH

  return lng.toLowerCase() as Language
}
